import request from './request';
import deserialize from './deserialize';

export type StampCard = {
  id: string;
  cardType: string;
  createdAt: number;
  quantity: number;
  redemptionCost: number;
  status: string;
  updatedAt: number;
  balance: number;
  pointsToDollar: number;
  user: { id: string };
  merchant: { id: string };
  reward: { id: string };
  stamp_campaign: { id: string };
  stampCampaignName: string;
};

export function get(companyId: string, memberId: string) {
  return request<StampCard>({
    url: `/companion/v1/companies/${companyId}/loyalty_card/membership/${memberId}`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

interface CreateAttrs {
  companyId: string;
  userID: string;
}

export function create(attrs: CreateAttrs) {
  const { companyId, userID } = attrs;

  return request<StampCard>({
    url: `/companion/v1/companies/${companyId}/stamp_card`,
    method: 'POST',
    data: {
      data: {
        attributes: {
          userID,
        },
      },
    },
    transformResponse: deserialize,
  });
}

interface CreditAttrs {
  companyId: string;
  stampCardId: string;
  numOfStamps: number;
  pin: string;
}

export function credit(attrs: CreditAttrs) {
  const { companyId, stampCardId, numOfStamps, pin } = attrs;

  return request<StampCard>({
    url: `/companion/v1/companies/${companyId}/stamp_cards/${stampCardId}/credit`,
    method: 'PATCH',
    data: {
      data: {
        attributes: {
          numOfStamps,
          pin,
        },
      },
    },
    transformResponse: deserialize,
  });
}

interface RemoveStampAttrs {
  companyId: string;
  stampCardId: string;
  numOfStamps: number;
}

export function removeStamp(attrs: RemoveStampAttrs) {
  const { companyId, stampCardId, numOfStamps } = attrs;

  return request({
    url: `/companion/v1/companies/${companyId}/stamp_cards/${stampCardId}/remove`,
    method: 'DELETE',
    data: {
      data: {
        attributes: {
          numOfStamps,
        },
      },
    },
    transformResponse: deserialize,
  });
}

interface ArchiveStampCardAttrs {
  companyId: string;
  cardId: string;
}

export function archiveStampCard(attrs: ArchiveStampCardAttrs) {
  const { companyId, cardId } = attrs;

  return request({
    url: `/companion/v1/companies/${companyId}/stamp_card/${cardId}/archive`,
    method: 'DELETE',
    transformResponse: deserialize,
  });
}

interface IssueCardAttrs {
  companyId: string;
  membershipID: string;
  stampCampaignIDs: string[];
}

export function issueCard(attrs: IssueCardAttrs) {
  const { companyId, membershipID, stampCampaignIDs } = attrs;

  return request<StampCard>({
    url: `/companion/v1/companies/${companyId}/stamp_card`,
    method: 'POST',
    data: {
      data: {
        attributes: {
          membershipID,
          stampCampaignIDs,
        },
      },
    },
    transformResponse: deserialize,
  });
}

export function listMembershipStampCard(
  companyId: string,
  membershipId: string
) {
  return request<StampCard[]>({
    url: `/companion/v1/companies/${companyId}/loyalty_card/membership/${membershipId}`,
    method: 'GET',
    transformResponse: deserialize,
  });
}
